/* header menu drawer menu link color js start */

document.addEventListener('DOMContentLoaded', function() {
  function styleEnergyLinks() {
    const textSpans = document.querySelectorAll('.menu-drawer__menu-item-text.wrap-text');

    textSpans.forEach((span) => {
      const text = span.textContent.trim();

      if (text.startsWith('Energy') && !span.classList.contains('styled-energy')) {
        const parts = text.split(' ');
        const firstWord = parts[0];
        const rest = parts.slice(1).join(' ');

        span.textContent = '';

        const energySpan = document.createElement('span');
        energySpan.className = 'osr-energy-text';
        energySpan.textContent = firstWord;

        const gumSpan = document.createElement('span');
        gumSpan.className = 'osr-gum-text';
        gumSpan.textContent = rest;

        span.appendChild(energySpan);
        if (rest) {
          span.appendChild(document.createTextNode(' '));
          span.appendChild(gumSpan);
        }

        span.classList.add('styled-energy');
      }
    });
  }

  styleEnergyLinks();

  const observer = new MutationObserver(() => {
    styleEnergyLinks();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


/* header menu drawer menu link color js end */

/* footer menu links color change js start */

document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('.list-unstyled .menu__item a');

  links.forEach((link) => {
    const text = link.textContent.trim();

    if (text.startsWith('Energy')) {
      const parts = text.split(' ');
      const gumPart = parts.slice(1).join(' ');

      link.textContent = '';

      const energySpan = document.createElement('span');
      energySpan.className = 'energy-text';
      energySpan.textContent = 'Energy';

      const gumSpan = document.createElement('span');
      gumSpan.className = 'gum-text';
      gumSpan.textContent = gumPart;

      link.appendChild(energySpan);
      link.appendChild(document.createTextNode(' '));
      link.appendChild(gumSpan);
    }
  });
});

/* footer menu links color change js end */

/* osr section slider js start */

document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper === "undefined") {
    console.warn("⚠️ Swiper not found — skipping initialization.");
    return;
  }

  const featureSlider = document.querySelector(".osr-feature-badge-slider-swiper");
  if (featureSlider) {
    new Swiper(featureSlider, {
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".osr-feature-badge-slider .swiper-pagination",
        clickable: true,
      },
      speed: 700,
      effect: "slide",
    });
  }

  const testimonialSlider = document.querySelector(".osr-testimonial-slider");
  if (testimonialSlider) {
    new Swiper(testimonialSlider, {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: ".osr-testimonial-next",
        prevEl: ".osr-testimonial-prev",
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 4 },
      },
    });
  }

  document.querySelectorAll("[data-swiper='auto']").forEach((el) => {
    if (!el.classList.contains("swiper-initialized")) {
      new Swiper(el, { loop: true, slidesPerView: 1 });
    }
  });  
});

/* osr section slider js end */

/* Show hero text on scroll js start */

document.addEventListener('DOMContentLoaded', function() {
  const heroTextElement = document.querySelector('.osr-text-show-only-mobile');

  if (heroTextElement) {
    let hasShown = false;

    function checkScroll() {
      const scrollPosition = window.scrollY;

      // Show text when user scrolls down 100px
      if (scrollPosition > 100 && !hasShown) {
        heroTextElement.classList.add('show-on-scroll');
        hasShown = true;
      }
      // Hide text when scrolled back to top
      else if (scrollPosition <= 100 && hasShown) {
        heroTextElement.classList.remove('show-on-scroll');
        hasShown = false;
      }
    }

    window.addEventListener('scroll', checkScroll);
  }
});

/* Show hero text on scroll js end */